import * as tslib_1 from "tslib";
import { AbstractionBase } from "@awayjs/core";
import { ChunkVO } from "../data/ChunkVO";
/**
 * ShaderChunkBase provides an abstract base method for shading methods, used by compiled passes to compile
 * the final shading program.
 */
var ShaderChunkBase = (function (_super) {
    tslib_1.__extends(ShaderChunkBase, _super);
    /**
     * Create a new ShaderChunkBase object.
     */
    function ShaderChunkBase(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this.chunkVO = new ChunkVO();
        _this._stage = shader._stage;
        return _this;
    }
    /**
     *
     */
    ShaderChunkBase.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._stage = null;
    };
    ShaderChunkBase.prototype._isUsed = function () {
        return true;
    };
    ShaderChunkBase.prototype._usesTangentSpace = function () {
        return true;
    };
    /**
     * Initializes the properties for a MethodVO, including register and texture indices.
     *
     * @param methodVO The MethodVO object linking this method with the pass currently being compiled.
     *
     * @internal
     */
    ShaderChunkBase.prototype._initVO = function (chunkVO) {
    };
    /**
     * Initializes unchanging shader constants using the data from a MethodVO.
     *
     * @param methodVO The MethodVO object linking this method with the pass currently being compiled.
     *
     * @internal
     */
    ShaderChunkBase.prototype._initConstants = function () {
    };
    /**
     * Resets the compilation state of the method.
     *
     * @internal
     */
    ShaderChunkBase.prototype._reset = function (chunkVO) {
        this._invalid = true;
        chunkVO.useChunk = false;
        chunkVO.needsProjection = false;
        chunkVO.needsView = false;
        chunkVO.needsNormals = false;
        chunkVO.needsTangents = false;
        chunkVO.needsGlobalVertexPos = false;
        chunkVO.needsGlobalFragmentPos = false;
        this._cleanCompilationData();
    };
    /**
     * Resets the method's state for compilation.
     *
     * @internal
     */
    ShaderChunkBase.prototype._cleanCompilationData = function () {
    };
    /**
     * Get the vertex shader code for this method.
     * @param vo The MethodVO object linking this method with the pass currently being compiled.
     * @param regCache The register cache used during the compilation.
     *
     * @internal
     */
    ShaderChunkBase.prototype._getVertexCode = function (registerCache, sharedRegisters) {
        return "";
    };
    /**
     * @inheritDoc
     */
    ShaderChunkBase.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        return "";
    };
    /**
     * Sets the render state for this method.
     *
     * @param methodVO The MethodVO object linking this method with the pass currently being compiled.
     * @param stage The Stage object currently used for rendering.
     *
     * @internal
     */
    ShaderChunkBase.prototype._activate = function () {
    };
    /**
     * Sets the render state for a single renderable.
     *
     * @param vo The MethodVO object linking this method with the pass currently being compiled.
     * @param renderable The renderable currently being rendered.
     * @param stage The Stage object currently used for rendering.
     * @param camera The camera from which the scene is currently rendered.
     *
     * @internal
     */
    ShaderChunkBase.prototype._setRenderState = function (renderable, projection) {
    };
    /**
     * Clears the render state for this method.
     * @param vo The MethodVO object linking this method with the pass currently being compiled.
     * @param stage The Stage object currently used for rendering.
     *
     * @internal
     */
    ShaderChunkBase.prototype._deactivate = function () {
        this._invalid = false;
    };
    return ShaderChunkBase;
}(AbstractionBase));
export { ShaderChunkBase };



// WEBPACK FOOTER //
// ../dist/lib/chunks/ShaderChunkBase.js